/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

import { createReducer } from 'state/utils';

const reportId = createReducer(null, {
	[actions.REPORT_BUILDER_START]: (state, action) => {
		return action.payload.reportId || null;
	},
	[actions.REPORT_BUILDER_STOP]: (state, action) => {
		return null;
	},
});

export default reportId;
